<div style="background-color: white; width: 100%; max-width: 538px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">
    <p class="bold-text">{{model.title}}</p>
    <p class="single-text" >{{model.description}}</p>   
   
    <div class="controls-container">
        <button class="btn btn-secondary" (click)="cancel()">{{model.cancelText}}</button>
        <button class="btn btn-primary" [disabled]="loadingModal" (click)="confirm()">
            @if(!loadingModal){
                <span>{{model.confirmText}}</span>
            } 
            @if(loadingModal){
                <span>
                    <i class="fas fa-sync-alt fa-spin" style="color: white;"></i>
                </span>
            }
            
        </button>
    </div>
</div>